import React, { useEffect, useState } from "react";
import "./masterPrompt.scss";
import MasterPromptList from "./MasterPromptList";
import PromptContent from "./PromptContent";
import ChevronLeft from "../history/AccordionTable/ChevronLeft";

export default function HistoryTable({ selectedGuardrail, setSelectedView }) {
  const [historyData, setHistoryData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [rowKey, setRowKey] = useState("");

  console.log(selectedGuardrail);

  useEffect(() => {
    if (selectedGuardrail?.history?.length > 0) {
      setHistoryData(selectedGuardrail.history);
      setHeaders(selectedGuardrail.history[0]?.headers ?? []);
      setRowKey(selectedGuardrail.history[0]?.rowKey ?? "");
    } else {
      setHistoryData([]);
      setHeaders([]);
      setRowKey("");
    }
  }, [selectedGuardrail]);

  const handleExpanded = (row) => {
    const index = expandedRowKeys.indexOf(row[rowKey]);
    if (index === -1) {
      setExpandedRowKeys([...expandedRowKeys, row[rowKey]]);
    } else {
      setExpandedRowKeys(expandedRowKeys.filter((key) => key !== row[rowKey]));
    }
  };

  const renderRowExpanded = (row) => {
    return (
      <div className="expanded-row-content">
        <p>{row.content}</p>
      </div>
    );
  };

  return (
    <div className="history-container">
      <button className="history-back-button" onClick={() => setSelectedView()}>
        &#60; Return
      </button>
      <div className="history-content">
        <div className="history-list-header">
          <h5>History of Prompt Content - Disallowed Topics</h5>
        </div>
        <div className="history-list">
          <table>
            <tbody>
              {historyData &&
                historyData?.map((row, rowIndex) => (
                  <React.Fragment key={row[rowKey] || rowIndex}>
                    <tr
                      className="table-row"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleExpanded(row);
                      }}
                    >
                      {headers.map((header, colIndex) => (
                        <td key={colIndex}>
                          {row[header.title.replace(" ", "")]}
                        </td>
                      ))}
                      <td>
                        <ChevronLeft
                          className={`chevron ${
                            expandedRowKeys.includes(row[rowKey])
                              ? "collapsed"
                              : "expanded"
                          }`}
                        />
                      </td>
                    </tr>
                    {expandedRowKeys.includes(row[rowKey]) && (
                      <tr className="expanded-row">
                        <td colSpan={headers.length + 1}>
                          {renderRowExpanded(row)}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
